import PropTypes from 'prop-types'
import React, { Fragment } from 'react'

import Checkbox from 'components/_form/Checkbox'
import { errorCustom, required } from 'forms/validations'
import useInViewCommon from 'hooks/useInViewCommon'
import { Col, Row } from 'styles/components/layout'
import { Text } from 'styles/components/typography'

import {
  ColStyled,
  RulesWrapper,
  Article,
  RulesEnd,
  Title,
  TextLHStyled,
} from './styles'

const ScrollableRules = ({
  title,
  agreement,
  haveToAgree,
  isDisabled,
  ...rules
}) => {
  const [rulesRef, inView] = useInViewCommon()
  return (
    <>
      <Row>
        <ColStyled width={{ xs: 1 }}>
          <Text
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          />
          <RulesWrapper>
            {Object.keys(rules).map(
              key =>
                !!rules[key] && (
                  <Fragment key={key}>
                    <Title
                      dangerouslySetInnerHTML={{
                        __html: rules[key].title,
                      }}
                    />
                    {rules[key].list.map(({ title, content }, idx) => (
                      <Article key={idx}>
                        <h4 dangerouslySetInnerHTML={{ __html: title }} />
                        <p dangerouslySetInnerHTML={{ __html: content }} />
                      </Article>
                    ))}
                  </Fragment>
                ),
            )}
            <RulesEnd ref={rulesRef} />
          </RulesWrapper>
        </ColStyled>
      </Row>
      <Row>
        <Col width={{ xs: 1 }}>
          <Checkbox
            name="is_offer_accepted"
            isDisabled={isDisabled || !inView}
            label={
              <TextLHStyled
                isDisabled={isDisabled || !inView}
                dangerouslySetInnerHTML={{
                  __html: agreement,
                }}
              />
            }
            validate={errorCustom(haveToAgree, required)}
          />
        </Col>
      </Row>
    </>
  )
}

ScrollableRules.propTypes = {
  title: PropTypes.string,
  agreement: PropTypes.string,
  haveToAgree: PropTypes.string,
  isDisabled: PropTypes.bool,
}

export default React.memo(ScrollableRules)
